// src/components/store/sections/faqs/FaqV47BentohelpCrimsonRose.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV47BentohelpCrimsonRose(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={47}
      archKey="bento_help"
      archLabel="Bento Help Matrix"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
